import MaxWidthLayout from './MaxWidthLayout';

export default MaxWidthLayout;
